<div class="w-full h-full flex items-center justify-center">
  <fun-register-identity-verification *ngIf="step === 1 && !loading" [profile]="profile"
    (finishEvent)="continue()"></fun-register-identity-verification>
  <fun-overal-message *ngIf="step === 2 && !loading" [text]="reviewText" [image]="12" [btnList]="initBtnList"
    (btnEvent)="continue()"></fun-overal-message>
  <div *ngIf="loading" class="pb-32"><fun-spinner></fun-spinner></div>
</div>